$(document).ready(() => {
  $('.media-gallery-wrapper').lightGallery({
    selector: '.media-gallery-item a',
    download: false,
    thumbnail: false
  })
})
